import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../components/event-selection/footer";
import Header from "../components/Header";
import { getReportingParams } from "../services/eventSelectionService";
import { Trans } from "react-i18next";

const FormLayout: React.FC = () => {
  const { perimeter, institutionId, period } = getReportingParams();

  return (
    <section>
      <Header />
      <div className="py-28 bg-[#E5E5E5]">
        <div className="pr-4 lg:px-10 mb-10 font-Poppins">
          <ul className="grid justify-items-end border-r border-[#1E408E] pr-5 text-xl text-[#1E408E]">
            <li>
              <Trans i18nKey="Perimeter">Perimeter</Trans>: {perimeter}
            </li>
            <li>
              <Trans i18nKey="Institution ID">Institution ID</Trans>:{" "}
              {institutionId}
            </li>
            <li>
              <Trans i18nKey="Reporting Date">Reporting Date</Trans>: {period.toDateString()}
            </li>
          </ul>
        </div>
        <Outlet />
      </div>
      <div className="relative mt-12">
        <Footer />
      </div>
    </section>
  );
};

export default FormLayout;
